import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";

import { DICTIONARY_TYPES, routes } from "consts";
import { PaziaInput, PaziaSelect } from "components/atoms";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PaziaButton } from "components/atoms";

const schema = yup
  .object({
    name: yup.string().required(),
    type: yup.number().required(),
  })
  .required();

export type CreateDictionaryValues = yup.InferType<typeof schema>;

interface CreateDictionaryFormProps {
  onSubmit: (data: CreateDictionaryValues) => void;
}

export const CreateDictionaryForm = ({ onSubmit }: CreateDictionaryFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const { handleSubmit } = methods;

  return (
    <div className="max-w-9xl mx-auto w-full px-4 py-8 sm:px-6 lg:px-8">
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Słownik", path: routes.DICTIONARIES }, { title: "Tworzenie słownika" }]}
        headerText="Dodaj nowy słownik"
      />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="grid max-w-xl gap-2 pt-4">
          <PaziaInput name="name" label="Nazwa" type="text" />
          <PaziaSelect label="Typ" name="type" options={DICTIONARY_TYPES} />

          <div className="pt-4">
            <PaziaButton title="Zapisz" type="success" />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
